<template>
	<payHeader :bgStatus="bgStatus"></payHeader>
	<div class="register-main">
		<div class="section register-auth">
			<p class="auth">注册成功，立即实名</p>
			<router-link to="/account" class="go">不要折扣，直接跳过</router-link>
			<ul>
			  <li class="person">
				<h4>个人认证</h4>
				<p>适用于个人用户，账号归属于个人</p>
				<p>享受云服务器9.5折优惠</p>
				<p>不支持开增值税专用发票</p>
				<router-link to="/verify/person" class="btn">选择并继续</router-link>
			  </li>
			  <li class="company">
				<span class="label">享9折优惠</span>
				<h4>企业认证</h4>
				<p>适用于企业、政府、事业单位、学校、组织等，账号归属于企业</p>
				<p>便于企业进行统一管理操作</p>
				<p>默认赠送1000条通用短信套餐包</p>
				<router-link to="/verify/business" class="btn">选择并继续</router-link>
			  </li>
			</ul>
		</div>
	</div>

	<payFooter></payFooter>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import { payHeader,payFooter } from 'landui-ui';
	
	const router = useRouter();
	const bgStatus = ref(true);
	
</script>

<style lang="scss" scoped>
	.register-auth{
		text-align: center;
		.auth{font-size: 20px; color: #79C472; margin-bottom: 25px;}
		.auth:before{content: "";display: block; width: 80px; height: 80px; margin:30px auto 22px;background: url(../../assets/images/sus.png) center top no-repeat;background-size: contain}
		.go{display: inline-block; padding-bottom: 5px; color: #999;border-bottom: 1px dashed #999999;}
		.go:hover{ color: #015BFE;}
		ul{ 
			margin-top:50px; 
			overflow: hidden;
			li{width: 290px; height: 380px; padding: 40px 26px 0;  display: inline-block; vertical-align: top; margin: 0 38px; background: #F2F5FA;position: relative;overflow: hidden}
			li:before{content: ""; width: 50px; height: 48px; display: block; margin: 0 auto 22px;}
			h4{font-size: 18px; margin-bottom: 25px;}
			p{ text-align: left; color: #666; padding-left: 20px; line-height: 26px;background: url(../../assets/images/ico.png) left 8px no-repeat}
			.label {position: absolute;right: 0;top: 0;width: 80px;padding-left: 5px;line-height: 25px;color: #fff;background: url(../../assets/images/label.png) center no-repeat;
			}
			.btn{position: absolute;left: 30px;right: 30px;bottom: 40px; background: #FFFFFF;line-height: 38px;color: #015BFE;border: 1px solid #015BFE;}
			.person:before{background: url(../../assets/images/auth_ico1.png) center no-repeat}
			.company:before{background: url(../../assets/images/auth_ico2.png) center no-repeat}
		}
	}
</style>